import { BOIDE_API_URL } from "@/lib/boide-api";

export interface TrackClickInput {
  referral_code?: string;
  track?: string;
}

/**
 * Ghi nhận click từ link tracking (?ref= / ?track=) — gọi từ browser để BE
 * ghi đúng IP người click. Fire-and-forget: nuốt mọi lỗi, không bao giờ
 * chặn hay làm sập render.
 */
export function trackClick(data: TrackClickInput): void {
  if (typeof window === "undefined") return;
  if (!data.referral_code && !data.track) return;
  try {
    void fetch(`${BOIDE_API_URL}/v1/tracking/click`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).catch(() => {
      // fail silently — tracking không được phép ảnh hưởng trang
    });
  } catch {
    // ignore
  }
}
